/*
this plugin creates a PaginationBreakdown once and only once
when converting a prosemirror document to printable HTML to
extract any/all blocks that are tracked changes that should be ignored

the same information is accessible in the live editor and static snapshots via
the inlinePagebreaks plugin
*/
import { EditorState, Plugin, PluginKey } from 'prosemirror-state'

import { getConfigData } from '#choo-app/lib/editor/plugins/configData'
import { getPageLayout } from '#util/PageLayout'
import { createPaginationBreakdown } from '#util/pagination'

const omittableBlockIdsKey = new PluginKey<string[]>('omittableBlockIds')

export function omittableBlockIdsPlugin() {
  return new Plugin({
    key: omittableBlockIdsKey,
    state: {
      init(_config, editorState) {
        const { currentBlockFormats, currentPageConfig } =
          getConfigData(editorState)

        const bd = createPaginationBreakdown({
          doc: editorState.doc,
          blockFormats: currentBlockFormats,
          pageLayout: getPageLayout(currentPageConfig),
          splitPoints: undefined,
        })

        return bd.blockIdsToOmit
      },
      apply(_, pluginState) {
        return pluginState
      },
    },
  })
}

export function getOmittableBlockIdsState(state: EditorState): string[] {
  return omittableBlockIdsKey.getState(state) ?? []
}
